import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "detail-wrapper" }
const _hoisted_2 = { class: "search-wrapper" }
const _hoisted_3 = { class: "tab-wrapper" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "filter-wrapper" }
const _hoisted_6 = { class: "search" }
const _hoisted_7 = { class: "search-content" }
const _hoisted_8 = { class: "search-btn" }
const _hoisted_9 = { class: "content-wrapper" }

import { ref, computed, onMounted } from "vue";
import store from "@/store";
import ValueOverview from "./components/valueOverview.vue";
import LeadContent from "./components/leadContent.vue";
import { mainApi, commonApi } from "@/services/api";
import { ElMessage } from "element-plus";
import { MacItem, RfsItem } from "@/model";

// table加载状态

export default /*@__PURE__*/_defineComponent({
  __name: 'asLeads',
  setup(__props) {

const tableLoading = ref<boolean>(false);

// 筛选参数
const filterData = ref({
  // 下发时间
  distributeLeadsTime: "",
  // 大区
  rfsCode: "",
  // 小区
  macCode: "",
});

// 默认页签
const tabId = ref("0");

// 四个页签
const tabs = [
  {
    id: "0",
    text: "保养线索",
  },
  {
    id: "3",
    text: "维修线索",
  },
  {
    id: "1",
    text: "保险线索",
  },
  {
    id: "2",
    text: "续保线索",
  },
];

// 大区列表
const rfsList = ref<RfsItem[]>([]);

// 小区列表
const macList = ref<MacItem[]>([]);

// 饼图概览数据
const PieData = ref();

// 线索概览数据
const overviewData = ref();

// 表格数据
const tableData = ref<{
  data: any[];
  total: number;
}>({
  data: [], // 表格数据
  total: 0,
});

// 页面分页数据
const paginationData = computed(() => store.state.leadsView.pageParams);

// 切换页签
const switchTab = (id: string) => {
  if (tabId.value === id) {
    return;
  }
  tabId.value = id;
  getPageList();
  getLeadsDataSummary();
};

// 获取入参
const getParams = () => {
  return {
    startDistributeLeadsTime: filterData.value.distributeLeadsTime
      ? filterData.value.distributeLeadsTime[0]
      : "",
    endDistributeLeadsTime: filterData.value.distributeLeadsTime
      ? filterData.value.distributeLeadsTime[1]
      : "",
    macCode: filterData.value.macCode,
    rfsCode: filterData.value.rfsCode,
    leadsType: tabId.value.toString(),
  };
};

// 重置当前搜索数据
const resetPage = () => {
  filterData.value = {
    distributeLeadsTime: "",
    rfsCode: "",
    macCode: "",
  };
  store.commit("setPageParams", {
    pageNO: 1,
    pageSize: 10,
  });
  getPageList();
  getLeadsDataSummary();
};

// 查询数据
const searchLeadsData = () => {
  getPageList();
  getLeadsDataSummary();
};

// 获取分页列表数
const getPageList = () => {
  tableLoading.value = true;
  const params = getParams();
  console.log("params :>> ", params);
  mainApi
    .getPageListApi({
      ...params,
      pageNO: paginationData.value.pageNO,
      pageSize: paginationData.value.pageSize,
    })
    .then((res: any) => {
      console.log("res :>> ", res);
      if (res?.success) {
        tableLoading.value = false;
        tableData.value.total = res.data.total;
        tableData.value.data = res.data.records;
      } else {
        tableLoading.value = false;
        ElMessage.error(res?.errMsg || "接口错误");
      }
    })
    .catch(() => {
      tableLoading.value = false;
    });
};

// 更新查询列表
const updatePageList = () => {
  getPageList();
};

// 查询大区列表
const queryRegionList = () => {
  commonApi.queryRegionListApi().then((res: any) => {
    console.log("res :>> ", res);
    if (res?.success) {
      rfsList.value = res?.data || [];
    }
  });
};

// 切换大区选择
const changeRfsCode = () => {
  filterData.value.macCode = "";
  // 查询小区列表
  commonApi.queryFmcListApi(filterData.value.rfsCode).then((res: any) => {
    if (res?.success) {
      macList.value = res?.data || [];
    }
  });
};

// 查询饼图概览数据
const getLeadsCountData = () => {
  mainApi.leadsCountByTypeApi().then((res: any) => {
    if (res?.success) {
      PieData.value = res?.data;
    }
  });
};

// 查询数据概览
const getLeadsDataSummary = () => {
  const params = getParams();
  const macName = macList.value.find(
    (item: MacItem) => item.fmcCode === params.macCode
  )?.fmcName;
  const rfsName = rfsList.value.find(
    (item: RfsItem) => item.regionCode === params.rfsCode
  )?.regionName;
  mainApi
    .obtainLeadsInfoCountApi({
      ...params,
      macName,
      rfsName,
    })
    .then((res: any) => {
      if (res?.success) {
        overviewData.value = res?.data;
      } else {
        ElMessage.error(res?.errMsg || "接口错误");
      }
    });
};

onMounted(async () => {
  getPageList();
  // 查询大区列表
  queryRegionList();
  // 查询饼图概览数据
  getLeadsCountData();
  // 查询数据概览
  getLeadsDataSummary();
});

return (_ctx: any,_cache: any) => {
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[6] || (_cache[6] = _createElementVNode("div", { class: "title" }, "售后线索大数据增效平台", -1)),
    _createVNode(ValueOverview, { "overview-data": PieData.value }, null, 8, ["overview-data"]),
    _createElementVNode("div", _hoisted_2, [
      _cache[5] || (_cache[5] = _createElementVNode("div", { class: "search-title" }, "线索详情信息", -1)),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(tabs, (item) => {
          return _createElementVNode("div", {
            key: item.id,
            class: _normalizeClass(["tab-item", tabId.value === item.id ? 'active' : '']),
            onClick: ($event: any) => (switchTab(item.id))
          }, _toDisplayString(item.text), 11, _hoisted_4)
        }), 64))
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_el_form, {
          ref: "formRef",
          "label-position": "right",
          model: filterData.value
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_el_row, { gutter: 20 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_col, { span: 8 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, { label: "下发时间" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_date_picker, {
                              modelValue: filterData.value.distributeLeadsTime,
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filterData.value.distributeLeadsTime) = $event)),
                              type: "daterange",
                              format: "YYYY-MM-DD",
                              "value-format": "YYYY-MM-DD",
                              "start-placeholder": "开始时间",
                              "end-placeholder": "结束时间"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 5 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          label: "大区",
                          prop: "rfsCode"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              modelValue: filterData.value.rfsCode,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filterData.value.rfsCode) = $event)),
                              clearable: "",
                              placeholder: "请选择大区",
                              onChange: changeRfsCode
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rfsList.value, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item.regionCode,
                                    label: item.regionName,
                                    value: item.regionCode
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 5 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          label: "小区",
                          prop: "macCode"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              modelValue: filterData.value.macCode,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((filterData.value.macCode) = $event)),
                              clearable: "",
                              placeholder: "请选择小区"
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(macList.value, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item.fmcCode,
                                    label: item.fmcName,
                                    value: item.fmcCode
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_el_button, {
                  type: "primary",
                  plain: "",
                  onClick: resetPage
                }, {
                  default: _withCtx(() => _cache[3] || (_cache[3] = [
                    _createTextVNode("重 置")
                  ])),
                  _: 1,
                  __: [3]
                }),
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: searchLeadsData
                }, {
                  default: _withCtx(() => _cache[4] || (_cache[4] = [
                    _createTextVNode("查 询")
                  ])),
                  _: 1,
                  __: [4]
                })
              ])
            ])
          ]),
          _: 1
        }, 8, ["model"])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(LeadContent, {
        loading: tableLoading.value,
        "list-data": tableData.value.data,
        "list-nums": tableData.value.total,
        "leads-type": tabId.value,
        "overview-data": overviewData.value,
        onUpdatePageList: updatePageList
      }, null, 8, ["loading", "list-data", "list-nums", "leads-type", "overview-data"])
    ])
  ]))
}
}

})